import React from "react";
import PropTypes from "prop-types";
import { PageLayout } from "../../components";
import { EstimatedOfferHelmet } from "../../components/SellHelmets";
import dayjs from "dayjs";
import { OfferCardPartExchange } from "./components";
import { useInitialOffer } from "../InitialOffer/useInitialOffer";
import { TellUsMoreCTA } from "./components/TellUsMoreCTA";
import { TellUsMoreModal } from "./components/TellUsMoreModal";
import { openTellUsMoreModal } from "../helpers";
import { useLocation } from "react-router-dom";
import { PriceIsAGuide } from "../../components/PriceIsAGuide/PriceIsAGuide";
import { PromoHeader } from "../../components/PromoHeader/PromoHeader";
import usePromoTicker from "../../hooks/usePromoTicker";
import { ValuationVehicleDetails } from "../../components/ValuationVehicleDetails/ValuationVehicleDetails";
import { MotExpired } from "../../components/MotExpired/MotExpired";

export default function EstimatedOfferPartExchange({
  onSubmit,
  showSpinner,
  percentageValue
}) {
  const {
    estimatedOfferCTA,
    handleTellUsMoreSubmit,
    promoActionNotRequired,
    promoApplied,
    showBranchValuationContent,
    showEstimatedOfferPartExchange,
    showExpired,
    showPromoBranding,
    stepNumber,
    subheaderTitle,
    tellUsMoreCardRef,
    valuation,
    getAssumptionsAnalytics
  } = useInitialOffer();

  const { handleApplyPromo, showLoader, startTicker } = usePromoTicker();

  const noBottomCardContent = !showExpired && showBranchValuationContent;
  const location = useLocation();
  const pathname = location.pathname;
  const analytics = getAssumptionsAnalytics("estimated");

  return (
    <>
      <>
        <EstimatedOfferHelmet />
        <PageLayout>
          <>
            <PageLayout.Header
              title={subheaderTitle}
              step={stepNumber}
              percentageValue={percentageValue}
            />
            <PageLayout.Content
              showPromoBranding={showPromoBranding}
              removeBottomPadding={!promoActionNotRequired || promoApplied}
            >
              {showPromoBranding && (
                <PromoHeader
                  promotionalBonus={valuation?.promotionalBonus}
                  promoApplied={promoActionNotRequired && !showLoader}
                />
              )}
              <ValuationVehicleDetails showPromoBranding={showPromoBranding} />
              <div
                className={`${
                  noBottomCardContent && valuation
                    ? "part-exchange-card-margin--no-content-below"
                    : ""
                } ${
                  !valuation ? "part-exchange-card-margin--no-valuation" : ""
                }`}
              >
                <OfferCardPartExchange
                  handleApplyPromo={handleApplyPromo}
                  showLoader={showLoader}
                  startTicker={startTicker}
                  onSubmit={onSubmit}
                  showSpinner={showSpinner}
                />
              </div>
              {promoActionNotRequired &&
                !showLoader &&
                (showExpired ||
                  (showEstimatedOfferPartExchange &&
                    !showBranchValuationContent)) && (
                  <div className="ch-pb--3 ch-ph--0 ch-bg--grey-1 part-exchange-card-border ch-bc--grey-3 ch-pt--2">
                    {showEstimatedOfferPartExchange &&
                      promoActionNotRequired && (
                        <TellUsMoreCTA
                          handleClick={openTellUsMoreModal}
                          tellUsMoreCardRef={tellUsMoreCardRef}
                        />
                      )}
                    {showExpired && <MotExpired now={dayjs()} />}
                  </div>
                )}

              {showEstimatedOfferPartExchange && (
                <TellUsMoreModal
                  tellUsMoreCardRef={tellUsMoreCardRef}
                  handleTellUsMoreSubmit={handleTellUsMoreSubmit}
                />
              )}
            </PageLayout.Content>
            <PageLayout.Footer
              position={`${promoActionNotRequired ? "page-layout--bottom-fixed-always" : ""}`}
              showShadow={false}
            >
              {valuation &&
              promoActionNotRequired &&
              !showBranchValuationContent ? (
                <button
                  className={`ch-btn ch-btn--success ch-display--flex ch-mh--auto sm:ch-width--6 md:ch-width--5 ch-width--12 lg:ch-width--4 ${
                    showSpinner ? "ch-btn--loading" : ""
                  }`}
                  type="button"
                  onClick={() => onSubmit(pathname)}
                  data-testid="initial-offer-cta"
                >
                  {estimatedOfferCTA}
                </button>
              ) : !promoActionNotRequired && valuation ? (
                <PriceIsAGuide analytics={analytics} />
              ) : null}
            </PageLayout.Footer>
          </>
        </PageLayout>
      </>
    </>
  );
}

EstimatedOfferPartExchange.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  showSpinner: PropTypes.bool
};
